<template>
  <v-container>
    <v-layout row wrap v-if="error">
      <v-flex lg12 md12 sm12 xs12 :class="['pa-2']">
        <v-alert :value="true">{{ error }}</v-alert>
      </v-flex>
    </v-layout>
    <v-layout row wrap v-if="gear" align-space-between fill-height>
      <v-flex lg6 md6 sm12 xs12 :class="['pa-2']">
        <v-card :class="['full-height']">
          <v-card-text :class="['fill-height']">
            <v-list dense two-line>
              <template v-for="(value, key) in gear" v-if="key !== 'images'">
                <v-list-tile ripple :key="key">
                  <v-list-tile-avatar>
                    <v-icon>mdi-information-outline</v-icon>
                  </v-list-tile-avatar>
                  <v-list-tile-content>
                    <v-list-tile-title v-html="key" />
                    <v-list-tile-sub-title v-html="value" />
                  </v-list-tile-content>
                </v-list-tile>
                <v-divider :key="`${key}-divider`" />
              </template>
            </v-list>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex lg6 md6 sm12 xs12 :class="['pa-2']">
        <v-card :class="['full-height']">
          <v-card-text :class="['pa-0']">
            <v-carousel>
              <v-carousel-item v-for="(item, i) in gear.images" :key="i" :src="makeImageUrl(item)" />
            </v-carousel>
          </v-card-text>
        </v-card>
      </v-flex>
      <featured-video />
    </v-layout>
    <news-ticker />
  </v-container>
</template>
<script>
import methods from '../mixins/methods'

export default {
  name: 'PageGearItem',
  mixins: [
    methods
  ],
  data () {
    return {
      gear: null,
      error: false,
      slug: this.$route.params.slug
    }
  },
  mounted () {
    this.getGear()
  },
  methods: {
    setGear (data) {
      if (data.images.length) {
        this.gear = data
      } else {
        this.error = this.$lang.gearNotFound
      }
    },
    getGear () {
      const slug = this.$route.path
      const cachedData = this.retrieveCachedData('gear', slug)
      if (cachedData) {
        return this.setGear(cachedData)
      }
      this.$http({
        url: this.getRoute('gear').url,
        method: 'POST',
        data: {
          slug: this.slug
        }
      }).then(response => {
        const data = response.data.data
        this.setGear(data)
        this.cacheData(slug, 'gear', data)
      }).catch(error => {
        console.log(error)
      })
    },
    makeImageUrl (url) {
      return url.replace('..', this.$config.mainSite)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/gear-item.vue